import { useRef, useState, useEffect, useContext } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Badge,
  Box,
  ClickAwayListener,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery
} from "@mui/material";

// project-imports
import MainCard from "components/MainCard";
import IconButton from "components/@extended/IconButton";
import Transitions from "components/@extended/Transitions";

// assets
import { UsdCoin,MoneyRecive } from "iconsax-react";
import Avatar from "components/@extended/Avatar";
import AuthContext from "../../../../contexts/JWTContext";
// types
import { ThemeMode } from "types/config";
// "../../../../pages/App_Catalogo/Transportista/Component";
import { Creditos } from "../../../../pages/App_Catalogo/Transportista/Component"; // Component";
const actionSX = {
  mt: "6px",
  ml: 1,
  top: "auto",
  right: "auto",
  alignSelf: "flex-start",

  transform: "none"
};

// ==============================|| HEADER CONTENT - NOTIFICATION ||============================== //

const NotificationPage = () => {
  const context = useContext(AuthContext);
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));

  const anchorRef = useRef<any>(null);
  const [read, setread] = useState(0);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const iconBackColorOpen =
    theme.palette.mode === ThemeMode.DARK ? "secondary.200" : "secondary.200";
  const iconBackColor =
    theme.palette.mode === ThemeMode.DARK
      ? "background.default"
      : "secondary.100";

  useEffect(() => {
    // if (!sessionStorage.getItem('isLoggedIn')) {
    //   navigate("/");
    // }
    Creditos(() => {})
      .then((respuesta: any) => {
        if (!respuesta.data.Error) {
          sessionStorage.setItem("Creditos", respuesta.data.Recordset[0].Creditos);
          setread(
            respuesta.data.Recordset[0].Creditos
              ? respuesta.data.Recordset[0].Creditos
              : 0
          );
        } else {
          setread(0);
        }
      })
      .catch((Error) => {
        setread(0);
      });
  }, [context?.state.transportista_,context?.state.op2]);

  return (
    <Box sx={{ flexShrink: 0, ml: 0.5 }}>
      <IconButton
        color="secondary"
        variant="light"
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? "profile-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        size="large"
        sx={{
          color: "secondary.main",
          bgcolor: open ? iconBackColorOpen : iconBackColor,
          p: 1
        }}
      >
        <Badge
           badgeContent={read !== 0 ? read : '0'}
          color={read === 0 ? "error" : "success"}
          sx={{ "& .MuiBadge-badge": { top: 2, right: 4, minWidth: "10px" } }}
        >
          <UsdCoin variant="Bold" />
        </Badge>
      </IconButton>
      <Popper
        placement={matchesXs ? "bottom" : "bottom-end"}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? -5 : 0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions
            type="grow"
            position={matchesXs ? "top" : "top-right"}
            sx={{ overflow: "hidden" }}
            in={open}
            {...TransitionProps}
          >
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                borderRadius: 1.5,
                width: "100%",
                minWidth: 285,
                maxWidth: 420,
                [theme.breakpoints.down("md")]: {
                  maxWidth: 285
                }
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography variant="h5">Creditos</Typography>
                    {/* <Link href="#" variant="h6" color="primary">
                      Mark all read
                    </Link> */}
                  </Stack>
                  <List
                    component="nav"
                    sx={{
                      "& .MuiListItemButton-root": {
                        p: 1.5,
                        my: 1.5,
                        border: `1px solid ${theme.palette.divider}`,
                        "&:hover": {
                          bgcolor: "primary.lighter",
                          borderColor: theme.palette.primary.light
                        },
                        "& .MuiListItemSecondaryAction-root": {
                          ...actionSX,
                          position: "relative"
                        }
                      }
                    }}
                  >
                    <ListItemButton>
                      <ListItemAvatar>
                        <Avatar type="filled">
                          <MoneyRecive size={20} variant="Bold" />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Typography variant="h6">
                           {sessionStorage.getItem('transportistaRazonSocial') + "   "}
                            <Typography component="span" variant="subtitle1">
                            </Typography>{" "}
                            {sessionStorage.getItem('aduana')}
                            
                          </Typography>
                        }
                        secondary=  {"(" + sessionStorage.getItem('transportista') + ")"}
                      />
                      <ListItemSecondaryAction>
                        <Typography variant="caption" noWrap>
                          {` Creditos: ${sessionStorage.getItem('Creditos')}`}
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItemButton>
                  </List>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default NotificationPage;
